import React from 'react';
import { createPortal } from 'react-dom';
import type { PortalDropdownCoords } from '../../hooks/usePortalDropdown';

interface PortalDropdownProps {
  open: boolean;
  coords: PortalDropdownCoords | null;
  dropdownRef: React.RefObject<HTMLDivElement>;
  /** Extra class on the panel for content-specific styling. */
  className?: string;
  children: React.ReactNode;
}

/**
 * Renders the panel of a `usePortalDropdown` into <body> with fixed
 * positioning (bottom-right anchored to the trigger), so it escapes any
 * ancestor overflow / scroll clipping.
 */
const PortalDropdown: React.FC<PortalDropdownProps> = ({
  open,
  coords,
  dropdownRef,
  className,
  children,
}) => {
  if (!open || !coords) {
    return null;
  }

  return createPortal(
    <div
      ref={dropdownRef}
      className={`portal-dropdown${className ? ` ${className}` : ''}`}
      style={{ position: 'fixed', top: coords.top, right: coords.right }}
    >
      {children}
    </div>,
    document.body
  );
};

export default PortalDropdown;
